var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFbShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.10476 19.3941C1.05026 19.3941 0.968519 19.3941 0.914023 19.3669C0.505303 19.2851 0.232824 18.9854 0.178328 18.5767C0.096584 18.0317 0.0693359 17.4868 0.0693359 16.9146C0.0693359 11.0835 4.37451 6.09713 10.1238 5.27969V2.14617C10.1238 1.68296 10.3963 1.24699 10.8595 1.05626C11.2955 0.865521 11.8132 0.974512 12.1402 1.30149L19.6606 8.82192C19.9331 9.0944 20.0693 9.42138 20.0693 9.80285C20.0693 10.1843 19.9331 10.5113 19.6606 10.7838L12.1129 18.3042C11.786 18.6312 11.2682 18.7402 10.8323 18.5494C10.3963 18.3587 10.0966 17.95 10.0966 17.4595V13.9718C6.71784 14.1898 3.66607 16.0426 1.89495 18.9309C1.73146 19.2306 1.43173 19.3941 1.10476 19.3941ZM11.4862 2.60939V5.41593C11.4862 6.01538 11.023 6.5331 10.4236 6.61484C5.2737 7.29604 1.40449 11.7375 1.40449 16.9146C1.40449 17.0236 1.40449 17.1325 1.40449 17.2415C3.50258 14.4622 6.71784 12.7456 10.2328 12.5821C10.5598 12.5549 10.8595 12.6911 11.1048 12.9091C11.35 13.1271 11.4862 13.4541 11.4862 13.7811V17.0236L18.6797 9.8301V9.80285L11.4862 2.60939Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbShare);
export default __webpack_public_path__ + "static/media/fbShare.4590aef1.svg";
export { ForwardRef as ReactComponent };